<template id="cp-edit">
    <div class="maxw">
        <h1>Productes - Client</h1>
        <b-form  v-on:submit.prevent="updateCP">
            <b-row>
                <b-col>
                <b-form-group label-class="font-weight-bold" label="Producte:">
                    {{ producte.producto.nombre }}
                </b-form-group>
                </b-col>
                <b-col>
                <b-form-group label-class="font-weight-bold" label="Cliente:">
                    {{ producte.cliente.nombre }}
                </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label-class="font-weight-bold" label="Titol Producte:*" label-for="input-titol">
                        <b-form-input
                            id="input-titol"
                            v-model="producte.productoTitulo"
                            required
                            maxlength = 100
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label-class="font-weight-bold" label="Descripció Producte:" label-for="textarea-descripcion">
                    <b-form-textarea
                      id="textarea-descripcion"
                      v-model="producte.productoDescripcion"
                      placeholder="Escriure descripció per al producte"
                      rows="3"
                      max-rows="4"
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="2">
                    <b-form-group label="Unitats:" label-class="font-weight-bold" label-for="input-unit">
                        <b-form-input
                        type="number"
                        :number="true"
                        required
                        id="input-unit"
                        v-model="producte.productoUnidades"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group label-class="font-weight-bold" label="Preu Unit.:(€)*" label-for="input-preu">
                        <b-form-input
                            type="number"
                            :number="true"
                            step="0.01" min="0.00"
                            id="input-preu"
                            required
                            v-model="producte.productoPrecio"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="2">
                    <b-form-group label-class="font-weight-bold" label="Preu Base: (€)">
                        {{ calculaPreu }}
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group label-class="font-weight-bold" label="Dte.:(%)" label-for="input-dte">
                        <b-form-input
                            type="number"
                            :number="true"
                            step="0.10" min="0.00"
                            id="input-dte"
                            v-model="producte.productoDescuento"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group label-class="font-weight-bold" label="Dte(€):">
                        {{ calculaDescompte }}
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group label-class="font-weight-bold" label="Importe(€):">
                        {{ producte.productoImporte = calculaImport }}
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label-class="font-weight-bold" label="Periode Facturació:(dies)*" label-for="input-periode">
                        <b-form-input
                            id="input-periode"
                            v-model="producte.productoDiasFacturacion"
                            type="number"
                            :number="true"
                            required
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group label-class="font-weight-bold" label="Repetitiu:" label-for="input-rep">
                        <b-form-checkbox v-model="producte.isRecurrente" name="check-button" switch>
                        Facturació Recurrent (vs Unica) <b>(Checked: {{ producte.isRecurrente }})</b>
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label-class="font-weight-bold" label="Actiu:" label-for="input-act">
                        <b-form-checkbox v-model="producte.isActive" name="check-button" switch>
                        <b>(Actiu: {{ producte.isActive }})</b>
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6"></b-col>
                <b-col class="col text-right">
                <b-button class="mr-2" variant="outline-success" type="submit">Gravar</b-button>
                <b-button class="mr-2" variant="outline-primary"><router-link :to="{ name: 'CPs'}">Cancel</router-link></b-button>
                </b-col>
            </b-row>
            <b-form-input :hidden="true" type="text" v-model="producte.identifier"></b-form-input>
            <b-form-input :hidden="true" type="text" v-model="producte.productoIdentifier"></b-form-input>
            <b-form-input :hidden="true" type="text" v-model="producte.clienteIdentifier"></b-form-input>
        </b-form>
    </div>
</template>

<script>
import DataAccess from '@/Services/DataAccess.js'

export default {
  props: {
    producte: {
      identifier: null,
      productoIdentifier: null,
      clienteIdentifier: null,
      productoTitulo: null,
      productoDescripcion: null,
      productoUnidades: null,
      productoPrecio: null,
      productoDescuento: null,
      productoImporte: null,
      productoDiasFacturacion: null,
      isRecurrente: null,
      isActive: null,
      fechaInicio: null
    }
  },
  data () {
    return {
      loading: true
    }
  },
  computed: {
    calculaPreu: function () {
      return (this.producte.productoPrecio * this.producte.productoUnidades)
    },
    calculaDescompte: function () {
      return (-this.calculaPreu * (this.producte.productoDescuento / 100))
    },
    calculaImport: function () {
      return (this.calculaPreu + this.calculaDescompte)
    }
  },
  methods: {
    updateCP () {
      (async () => {
        await DataAccess.putData('/api/clientProd', this.producte.identifier, {
          identifier: this.producte.identifier,
          productoIdentifier: this.producte.productoIdentifier,
          clienteIdentifier: this.producte.clienteIdentifier,
          productoTitulo: this.producte.productoTitulo,
          productoDescripcion: this.producte.productoDescripcion,
          productoUnidades: this.producte.productoUnidades,
          productoPrecio: this.producte.productoPrecio,
          productoDescuento: this.producte.productoDescuento,
          productoImporte: this.producte.productoImporte,
          productoDiasFacturacion: this.producte.productoDiasFacturacion,
          isRecurrente: this.producte.isRecurrente,
          isActive: this.producte.isActive,
          fechaInicio: this.producte.fechaInicio
        })
          .then(response => {
            this.$router.push({ name: 'CPs' })
          })
          .catch(error => {
            console.log('ERROR: ', error)
          })
      })()
    }
  }
}
</script>

<style scoped>
  .maxw {
    width: 80%;
    margin: 40px auto;
  }
</style>
